export const offscreenCanvasSupport = () => {
  return window.OffscreenCanvas !== undefined;
};
